export default {
  NewRoleAdd: 'نقش جدید اضافه شد',
  NewRealmAdd: 'قلمرو جدید اضافه شد',
  PermissionUpdate: 'مجوز بروزرسانی شد',
  RealmUpdate: 'قلمرو بروزرسانی شد',
  RoleUpdate: 'نقش بروزرسانی شد',
  RealmRemoved: 'نقش ها حذف شد',
  RoleRemoved: 'نقش حذف شد',
  Realms: 'حوزه های دید',
  Agent: 'عامل',
  Permissions: 'سطوح دسترسی',
  AccessPanel: 'دسترسی به پنل',
  ClientType: 'نوع ',
  CreationTime: 'زمان ثبت',
  CreationTimeMin: 'زمان ثبت از',
  CreationTimeMax: 'زمان ثبت تا',
  Role: 'نقش ها',
  RoleScope: 'حوزه نقش',
  Realm: 'قلمرو',
  Order: 'ترتیب',
  NodeType: 'نوع گره',
  Traversal: 'ارث بری خودکار',
  SerialNumber: 'شماره سریال',
  ProxyIP: 'آی پی پروکسی',
  Version: 'ورژن',
  VersionTime: 'زمان نسخه',
  Host: 'میزبان',
  Slug: 'Slug',
  Os: 'سیستم عامل',
  MainIP: 'IP اصلی',
  Enable: 'فعال',
  Scope: 'حوزه',
  minimum: 'حداقل',
  maximum: 'حداکثر',
  limitType: 'نوع محدودیت',
  editPermission_: 'ویرایش دسترسی {title}',
  licenseScope: 'حوزه مجوز',
  selectAtLeastOnePermissionForThisLicense:
    'حداقل یک دسترسی برای این مجوز انتخاب شود',

  mainIP: 'IP اصلی',
  proxyIP: 'آی پی پروکسی',
  host: 'میزبان',
  os: 'سیستم عامل',
  agent: 'عامل',
  clientType: 'نوع کلاینت',
  creationTime: 'زمان ثبت',
  serialNumber: 'شماره سریال کلاینت',
  version: 'ورژن کلاینت',
  parameter: 'پارامتر',
  makeTheDesireFormulaWithTheFollowingWords:
    'با کلمات زیر فرمول مورد نظر را بسازید',
  formulaMaker: 'فرمول ساز',
  service: 'سرویس',
  operation: 'عملیات',
  type: 'نوع',
  pleasePickServiceAndOperation: 'لطفا سرویس و عملیات را انتخاب کنید',
  ignoreExpression: 'شروط Ignore',
  userExpression: 'شروط مبتنی بر کاربر',
  generalExpression: 'شروط عموم کاربران',
  parameters: 'پارامتر ها',
  areYouSureYouWantToDisableThisLimit: 'آیا از غیرفعال کردن این حدود اختیار اطمینان دارید؟',
  areYouSureYouWantToRemoveThisLimit: 'آیا از حذف این حدود اختیار اطمینان دارید؟',
  method: 'نوع درخواست',
  url: 'Url',
  roleId: 'شناسه نقش',
  permissionId: 'شناسه سطح دسترسی',
  role: 'نقش ها',
  realms: 'حوزه های دید',
  roleInfo: 'اطلاعات نقش',
  licensePermissionInfo: 'اطلاعات مجوز سطح دسترسی'
}
